export const twoByOneUsers = ["fwytsXGE66ULVuP0Ie6auDVjKam1"]
